export enum SubcategoryVehicleModel {
  LIGHT = 'LIGHT', // Leve

  MEDIUM_LIGHT = 'MEDIUM_LIGHT', // Semi-leve

  MEDIUM = 'MEDIUM', // Médio

  MEDIUM_HEAVY = 'MEDIUM_HEAVY', // Semi-pesado

  HEAVY = 'HEAVY', // Pesado
}
